<template>
    <router-view v-if="loaded" :index="index"></router-view>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    export default {
        name: "PopulateMatrix",

        data() {
            return {
                loaded: false,
            }
        },

        props: ['id', 'index'],

        computed: {
            ...mapState('data', {
                'dataMatrix': state => state.matrix
            })
        },

        methods: {
            ...mapMutations('data', [
                'commitMatrix',
                'commitScoreCard',
                'commitEditMatrix'
            ])
        },

        created() {
            let storageKey = 'data';

            if(this.id == 'NULL') {

                let data = localStorage.getItem(storageKey);
                if (data !== null) {
                    this.commitMatrix(JSON.parse(data).matrix);
                }

                this.loaded = true


            }else{
                storageKey = 'matrix_' + this.id;

                if(localStorage.getItem(storageKey)) {
                    console.log('set storage data')
                    //load from local storage
                    this.commitMatrix(JSON.parse(localStorage.getItem(storageKey)).matrix);
                    this.commitScoreCard(JSON.parse(localStorage.getItem(storageKey)).matrix.scoreCard);
                    this.loaded = true;

                }else{
                    console.log('get from db')
                    const vm = this;
                    $.ajax({
                        url: '/matrices/' + this.id,
                        method: 'GET',
                        contentType: 'application/json',
                        dataType: 'json',

                    })
                        .fail()
                        .done(function (response) {
                            vm.commitMatrix(response.matrix);
                            vm.commitScoreCard(JSON.parse(response.matrix.scores[0].scores).score_card)
                            console.log('committed')

                            //set local storage item
                            localStorage.setItem(storageKey, JSON.stringify(vm.$store.state.data));

                            vm.loaded = true;
                        });
                }
            }

            this.$store.subscribe((mutation, state) => {
                localStorage.setItem(storageKey, JSON.stringify(state.data));
                //localStorage.setItem('editData', JSON.stringify(state.data.editMatrix));
            });


        }
    }
</script>

<style scoped>

</style>